export const FETCH_USER_BEGAN = 'userById/FETCH_USER_BEGAN'
export const FETCH_USER_SUCCESS = 'userById/FETCH_USER_SUCCESS'
export const FETCH_USER_FAILED = 'userById/FETCH_USER_FAILED'
export const ADD_BATTERY_TO_USER_FAILED = 'batteryById/ADD_BATTERY_TO_USER_FAILED'
export const ADD_BATTERY_TO_USER_SUCCESS = 'batteryById/ADD_BATTERY_TO_USER_SUCCESS'
export const ADD_BATTERY_TO_USER_BEGAN = 'batteryById/ADD_BATTERY_TO_USER_BEGAN'
export const REMOVE_USER_FAILED = 'userById/REMOVE_USER_FAILED'
export const REMOCE_USER_SUCCESS = 'userById/REMOCE_USER_SUCCESS'
export const REMOVE_USER_BEGAN = 'userById/REMOVE_USER_BEGAN'